import { Component, Input, OnInit, inject } from "@angular/core";
import { RiskDataService } from "@app/risk/services/RiskDataService";
import { MatrixModel } from "@models/generic/MatrixModel";
import { firstValueFrom } from "rxjs";
import { CerrixRiskMatrixComponent } from "@app/shared/components/cerrix-riskmatrix/cerrix-riskmatrix.component";

@Component({
    selector: "business-risks-widget",
    templateUrl: "./business-risks-widget.component.html",
    styleUrls: ["./business-risks-widget.component.scss"],
    imports: [CerrixRiskMatrixComponent],
})
export class BusinessRisksWidgetComponent implements OnInit {
    private _riskDS = inject(RiskDataService);

    @Input() businessDimensionId: number;
    @Input() orgId: number;

    netMatrix: MatrixModel;
    grossMatrix: MatrixModel;

    async ngOnInit() {
        this.netMatrix = await firstValueFrom(this._riskDS
            .getRiskMatrixChart(this.getMatrixChartConfig("Net")));

        this.grossMatrix = await firstValueFrom(this._riskDS
            .getRiskMatrixChart(this.getMatrixChartConfig("Gross")));
    }

    private getMatrixChartConfig(netOrGross: "Net" | "Gross") {
        return {
            Organization: this.orgId,
            OrganizationIncludeChildren: true,

            BusinessDimension: this.businessDimensionId,
            BusinessDimensionIncludeChildren: true,

            FrameworkDimension: null,
            FrameworkDimensionIncludeChildren: false,

            NetGross: netOrGross == "Net" ? 1 : 2,
            ImpactScale: null,
            RiskCatalogue: null,
        };
    }
}
